/* eslint-disable */

/*
 * ⚠️ DO NOT EDIT ⚠️
 * This file is automatically generated, run "yarn run codegen"
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type TournamentPhase_GetPhaseQueryVariables = Exact<{
  phaseId: number;
}>;

export type TournamentPhase_GetPhaseQuery = {
  __typename: 'query_root';
  tournaments_phase_by_pk:
    | {
        __typename: 'tournaments_phase';
        id: number;
        name: string | undefined;
        rank: unknown;
        engagements:
          | Array<{
              __typename: 'tournaments_engagement';
              id: number;
              name: string | undefined;
              ranking:
                | {
                    __typename: 'tournaments_ranking';
                    rank: unknown;
                    id: number;
                    pts: unknown;
                    played: unknown;
                    win: unknown;
                    lost: unknown;
                    even: unknown;
                    gf: unknown;
                    ga: unknown;
                    gd: unknown;
                    bonus: unknown;
                  }
                | undefined;
              team:
                | {
                    __typename: 'tournaments_team';
                    id: number;
                    name: string | undefined;
                    logo: string | undefined;
                  }
                | undefined;
            }>
          | undefined;
        games:
          | Array<{
              __typename: 'tournaments_games_in_phase';
              game:
                | {
                    __typename: 'tournaments_game';
                    id: number;
                    date: unknown;
                    name: string | undefined;
                    place: string | undefined;
                    game_type: unknown;
                    url: string | undefined;
                    status: string | undefined;
                    home_score: number | undefined;
                    home_score_data: unknown;
                    home_shootout: number | undefined;
                    away_score: number | undefined;
                    away_score_data: unknown;
                    away_shootout: number | undefined;
                    home_engagement:
                      | {
                          __typename: 'tournaments_engagement';
                          id: number;
                          name: string | undefined;
                          team:
                            | {
                                __typename: 'tournaments_team';
                                id: number;
                                name: string | undefined;
                                logo: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    away_engagement:
                      | {
                          __typename: 'tournaments_engagement';
                          id: number;
                          name: string | undefined;
                          team:
                            | {
                                __typename: 'tournaments_team';
                                id: number;
                                name: string | undefined;
                                logo: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }>
          | undefined;
        rule:
          | {
              __typename: 'tournaments_challenge_rule';
              id: number;
              name: string | undefined;
              nb_groups: unknown;
              nb_teams: unknown;
              nb_teams_in_final_phase: unknown;
              period_duration: unknown;
              rank: unknown;
              rule_type: unknown;
              time_between_periods: unknown;
              period_nb: unknown;
            }
          | undefined;
      }
    | undefined;
  tournaments_tournament:
    | Array<{
        __typename: 'tournaments_tournament';
        id: number;
        name: string | undefined;
        sport_id: number | undefined;
        challenges:
          | Array<{
              __typename: 'tournaments_challenge';
              id: number;
              name: string | undefined;
            }>
          | undefined;
      }>
    | undefined;
};

export const TournamentPhase_GetPhaseDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TournamentPhase_GetPhase' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'phaseId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tournaments_phase_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'phaseId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'engagements' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'initial_rank' },
                            value: { kind: 'EnumValue', value: 'asc' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ranking' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rank' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pts' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'played' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'win' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lost' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'even' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gf' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ga' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gd' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bonus' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'logo' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'games' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'game' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'date' },
                                      value: {
                                        kind: 'EnumValue',
                                        value: 'asc',
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'game' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'place' },
                                      value: {
                                        kind: 'EnumValue',
                                        value: 'asc',
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'game' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'place' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'game_type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'home_score' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'home_score_data' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'home_shootout' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'away_score' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'away_score_data' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'away_shootout' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'home_engagement' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'team' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'logo' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'away_engagement' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'team' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'logo' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nb_groups' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nb_teams' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'nb_teams_in_final_phase',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'period_duration' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rule_type' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'time_between_periods' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'period_nb' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tournaments_tournament' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'challenges' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'rules' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'phases' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: {
                                                kind: 'Name',
                                                value: '_eq',
                                              },
                                              value: {
                                                kind: 'Variable',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'phaseId',
                                                },
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sport_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenges' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'rules' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'phases' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: {
                                                kind: 'Name',
                                                value: '_eq',
                                              },
                                              value: {
                                                kind: 'Variable',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'phaseId',
                                                },
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TournamentPhase_GetPhaseQuery,
  TournamentPhase_GetPhaseQueryVariables
>;
